var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.color,attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{staticClass:"a",attrs:{"d":"M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z"}}),_c('path',{staticClass:"b",attrs:{"d":"M0,10H6V0","transform":"translate(13.071 4) rotate(45)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }